var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.327,
    height: 18,
    viewBox: "0 0 18.327 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M461.82,1138.75h-1.261a.181.181,0,0,0-.181.18v1.45H445.62v-14.76h14.76v1.45a.181.181,0,0,0,.181.18h1.261a.181.181,0,0,0,.18-.18v-2.35a.717.717,0,0,0-.719-.72H444.72a.718.718,0,0,0-.72.72v16.56a.718.718,0,0,0,.72.72h16.56a.718.718,0,0,0,.72-.72v-2.35A.181.181,0,0,0,461.82,1138.75Zm.435-5.9-3.325-2.62a.188.188,0,0,0-.3.15v1.78h-7.359a.184.184,0,0,0-.188.18v1.32a.184.184,0,0,0,.188.18h7.359v1.78a.188.188,0,0,0,.3.15l3.325-2.62a.177.177,0,0,0,.053-.07.178.178,0,0,0,0-.16A.177.177,0,0,0,462.255,1132.85Z",
    transform: "translate(-444 -1124)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ac5e9a03e35101fa1a53568e1264e9e0.svg";
export { ForwardRef as ReactComponent };